import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useAudience } from '../contexts/AudienceContext';

const ConversionCtaBand = ({ onStudentAction, onSchoolAction }) => {
  const { isSchool } = useAudience();

  return (
    <section
      className="py-16 md:py-20 relative overflow-hidden"
      aria-label="Call to action"
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900 via-blue-800 to-teal-900" />
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 right-0 w-96 h-96 bg-teal-400 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-blue-400 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10 text-center max-w-3xl">
        <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-teal-100 mb-6">
          <Sparkles className="h-4 w-4" />
          {isSchool ? 'School programs open' : 'Start with clarity'}
        </div>
        <h2 className="font-display text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
          {isSchool
            ? 'Show your community one career story, not fifteen conflicting ones'
            : 'Swap vague worry for a Career DNA report that sounds like your real life.'}
        </h2>
        <p className="text-lg text-blue-100/95 mb-8 leading-relaxed">
          {isSchool
            ? 'Book a focused demo, walk through the Career DNA framework, see sample PDFs, and map rollout options with a partner lead who knows schools.'
            : 'Built for Class 9 to 12. Finish in one sitting, keep a clear PDF, and tap experts only if you want a human in the loop.'}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {isSchool ? (
            <Button
              type="button"
              size="lg"
              onClick={onSchoolAction}
              className="bg-white text-blue-900 hover:bg-blue-50 font-semibold px-8 py-6 text-lg shadow-xl"
            >
              Book a school demo
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          ) : (
            <Button
              type="button"
              size="lg"
              onClick={onStudentAction}
              className="bg-white text-blue-900 hover:bg-blue-50 font-semibold px-8 py-6 text-lg shadow-xl"
            >
              Know your Career DNA
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ConversionCtaBand;
